/*
 * Copyright (c) 2024. . Yantodev - All Rights Reserved.
 * @Author  :  yantodev
 * mailto : ekocahyanto007@gmail.com
 * link : https://yantodev.my.id/
 */

import React, {lazy, useEffect, useState} from 'react'
import './App.css';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom'
import { themeChange } from 'theme-change'
import checkAuth from './app/auth';
import initializeApp from './app/init';
import { ResetPassword } from "./pages/ResetPassword";
import {useSelector} from "react-redux";


// Importing pages
const Layout = lazy(() => import('./containers/Layout'))
const Login = lazy(() => import('./pages/Login'))
const ForgotPassword = lazy(() => import('./pages/ForgotPassword'))
const Register = lazy(() => import('./pages/Register'))
const Documentation = lazy(() => import('./pages/Documentation'))


// Initializing different libraries
initializeApp().then()


// Check for login and initialize axios
const token = checkAuth()

function App() {
    const [isNight, setIsNight] = useState(false);
    const title = useSelector(({header}) => header.pageTitle);
    useEffect(() => {
        document.title = title;
        // Get the current hour
        const hour = new Date().getHours();

        // If it's night (e.g., after 6 PM or before 6 AM), set the theme to dark
        if (hour >= 18 || hour < 6) {
            setIsNight(true);
        } else {
            setIsNight(false);
        }
    }, [title]);

    useEffect(() => {
        // Apply the theme change based on the time of day
        const theme = isNight ? "dark" : "light"; // Determine theme name
        document.documentElement.setAttribute("data-theme", theme); // Set the theme attribute
        themeChange(false); // Reinitialize theme-change
    }, [isNight]);

    return (
        <>
            <Router>
                <Routes>
                    <Route exac path="/login" element={<Login />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/documentation" element={<Documentation />} />
                    <Route path="/auth/reset" element={<ResetPassword />} />

                    {/* Place new routes over this */}
                    <Route path="/app/*" element={<Layout />} />

                    <Route path="*" element={<Navigate to={token ? "/app/dashboard" : "/login"} replace />} />

                </Routes>
            </Router>
        </>
    )
}

export default App
